<ng-container *transloco="let t;">
    <div class="badge" [ngClass]="badgeCssClass">
        {{ status | titlecase | documentStatusName}}
    </div>
</ng-container>
